import { Box, Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSignalFilters } from '../context';

export const SignalFilterChips = () => {
  const { t } = useTranslation();
  const { filters, setFilter } = useSignalFilters();

  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
      {filters.kind.items
        .filter((f) => f.selected)
        .map((f) => {
          const value =
            f.value === 'EVENT'
              ? t('pages.device_signals.settings.fields.kind.event')
              : t('pages.device_signals.settings.fields.kind.manual');
          return (
            <Chip
              key={`kind-${f.value}`}
              label={t('common.labels.type_with_value', { value })}
              color="primary"
              onDelete={() => {
                const items = filters.kind.items.map((x) =>
                  x.value === f.value ? { ...x, selected: false } : x,
                );
                setFilter({ field: 'kind', items });
              }}
            />
          );
        })}
      {filters.eventType.items
        .filter((f) => f.selected)
        .map((f) => (
          <Chip
            key={`eventType-${f.value}`}
            label={t('pages.device_signals.list.columns.event_type_with_value', { value: f.label })}
            color="primary"
            onDelete={() => {
              const items = filters.eventType.items.map((x) =>
                x.value === f.value ? { ...x, selected: false } : x,
              );
              setFilter({ field: 'eventType', items });
            }}
          />
        ))}
      {filters.action.items
        .filter((f) => f.selected)
        .map((f) => {
          const value = t(`pages.device_signals.settings.actions.${f.value.toLowerCase()}`);
          return (
            <Chip
              key={`action-${f.value}`}
              label={t('common.labels.action_with_value', { value })}
              color="primary"
              onDelete={() => {
                const items = filters.action.items.map((x) =>
                  x.value === f.value ? { ...x, selected: false } : x,
                );
                setFilter({ field: 'action', items });
              }}
            />
          );
        })}
      {filters.tags.items
        .filter((f) => f.selected)
        .map((f) => (
          <Chip
            key={`tags-${f.value}`}
            label={t('common.labels.tags_with_value', { value: f.label })}
            color="primary"
            onDelete={() => {
              const items = filters.tags.items.map((x) =>
                x.value === f.value ? { ...x, selected: false } : x,
              );
              setFilter({ field: 'tags', items });
            }}
          />
        ))}
    </Box>
  );
};
